/**
 * Serves as the form's data definition (DTO). Taken as the "data" prop
 * for the AudienceForm component.
 */
export default class AudienceFormData {
  constructor(id, name, scope, assignments) {
    this.id = id;
    this.name = name;
    this.scope = scope;
    this.assignments = assignments;
  }
}
